import { FC } from "react";
import { Grid, Title, Text, Logo } from "../components/imprint";

const ImprintPage: FC = () => {
    return (
        <Grid>
            <Title>Imprint</Title>
            <Text>
                {" "}
                Offsetted UG
                <br />
                c/o Factory Hammerbrooklyn
                <br />
                Stadtdeich 2-4
                <br />
                20097 Hamburg
                <br />
                Germany
                <br />
                <br />
                E-mail: hello@offsetted.com
                <br />
                Website: www.offsetted.com
                <br />
                Registry court: Handelsregister B des Amtsgerichts Hamburg
                <br />
                Registry court number: HRB 173618
                <br />
                Managing Directors: Aleksandr Lazarenko, Daria Lipatova
                <br />
                VAT ID (USt.-ID): 4674805352
                <br />
                <Logo src='logo.svg' />
                <br />
                <Text>
                    Offsetted, founded in Germany in 2022, is a sustainability data management
                    platform. Offsetted sets organizations on the path to net zero with enterprise
                    software allowing for measuring, monitoring, reducing, compensating,
                    communicating, and reporting their emissions in compliance with the globally
                    recognised frameworks for impact assessment.
                </Text>
            </Text>
        </Grid>
    );
};
export default ImprintPage;
